export const CursorTool = {
	SELECT: 0, // The default value.
	HAND: 1,
	ZOOM: 2
};
